import React from 'react'
import { checkTextTranslation, checkTranslation } from '../../utils/useful'

class StaticText extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }


    focus = () => {
        this.input.focus()
    }
    selectHandler = () => {
        // console.log('sssssssssssssssss');
    }


    render() {
        let information = this.props.header?.information
        return (
            <div className="w-100 h-100"  >
                {/* <input ref={el => this.input = el} autoFocus={this.props.header.information.autoFocus} spellCheck={this.props.header.information.spellCheck} value={this.props.data ? checkTranslation(this.props.data) : ''} onChange={(e) => this.changeInputValue(e.target)} placeholder={checkTranslation(this.props.header.information.placeholder)} disabled={this.props.header.information?.disabled} className="transpanet-input" /> */}
                <p style={{ color: information?.color, fontWeight: information?.fontWeight, fontSize: information?.fontSize }} >{this.props.header?.information?.label}</p>
            </div>
        )
    }
}

export default StaticText;